<script setup>
import { cdnImageUrl } from '@dpgradio/creative'

const props = defineProps({
  track: Object,
  position: Number,
  currentPosition: Number,
  chart: Object,
  rowClass: String,
  textClass: String,
  positionClass: String,
  movementClass: String,
  placeholderClass: Array,
  thumbnailSize: { type: String, default: 'w480' },
})

const currentTextColor = (fallback = 'text-q-cr-red-primary') => {
  return props.track?.position === props.currentPosition ? 'text-white' : fallback
}
</script>

<template>
  <div class="flex items-center" :class="[currentPosition == position ? 'bg-q-cr-red-primary' : '', currentTextColor('text-q-cr-gray-primary'), rowClass]">
    <img class="object-cover h-full aspect-square rounded-xl" :src="cdnImageUrl(track?.thumbnail || '/e/18/f5/24/1579728/geheim.png', thumbnailSize)" />

    <div v-if="track" class="flex-1" :class="textClass">
      <div class="font-bold line-clamp-1">{{ track.artist?.name }}</div>
      <div class="line-clamp-1">{{ track.title }}</div>
    </div>

    <div v-else class="flex-1 space-y-2">
      <div class="bg-gray-200 animate-pulse blur-sm" :class="placeholderClass?.[0]" />
      <div class="bg-gray-200 animate-pulse blur-sm" :class="placeholderClass?.[1]" />
    </div>

    <div class="flex flex-col items-end justify-center">
      <div class="font-bold" :class="[currentTextColor(), positionClass]">#{{ position }}</div>
      <div v-if="track" :class="movementClass">
        <span v-if="track.previous_position === null || track.previous_position === undefined">
          <span v-if="track.reentry">Re-entry</span>
          <span v-if="chart.listEditionsCount > 1 && track.times_in_list === 1">Nieuw</span>
        </span>
        <div
          v-else-if="track.position !== track.previous_position"
          class="flex items-center justify-center gap-2 font-bold text-3xl"
          :class="track.position > track.previous_position ? currentTextColor() : currentTextColor('text-green-500')"
        >
          {{ track.previous_position - track.position }}
          <span v-if="track.position > track.previous_position">⏷</span>
          <span v-else>⏶</span>
        </div>
        <span v-else class="font-bold">=</span>
      </div>
    </div>
  </div>
</template>
